<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 4" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row v-for="item in 3" :key="item">
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <!-- <v-row>
        <v-col cols="3">
          <v-switch v-model="form.webrtc" label="webrtc" dense />
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.numero"
            :counter="10"
            :disabled="desativado"
            type="number"
            label="Número"
            outlined
            :error-messages="numeroErrors"
            @input="$v.form.numero.$touch()"
            @blur="$v.form.numero.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.usuario"
            :error-messages="usuarioErrors"
            :counter="30"
            label="Nome"
            outlined
            @input="
              $v.form.usuario.$touch()
              form.usuario = $event.trim()
            "
            @blur="$v.form.usuario.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.senhaRamal"
            :error-messages="senhaRamalErrors"
            :counter="20"
            label="Senha"
            outlined
            @input="
              $v.form.senhaRamal.$touch()
              form.senhaRamal = $event.trim()
            "
            @blur="$v.form.senhaRamal.$touch()"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            dense
            v-model.number="form.limiteLogin"
            :error-messages="limiteLoginErrors"
            :counter="2"
            type="number"
            label="Registros Simultâneos"
            outlined
            @input="$v.form.limiteLogin.$touch()"
            @blur="$v.form.limiteLogin.$touch()"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            dense
            v-model.number="form.quantidadeChamadasParaOcupado"
            :error-messages="quantidadeChamadasParaOcupadoErrors"
            :counter="2"
            type="number"
            label="Quantidade Ligações de Entrada"
            outlined
            @input="$v.form.quantidadeChamadasParaOcupado.$touch()"
            @blur="$v.form.quantidadeChamadasParaOcupado.$touch()"
          />
        </v-col>
        <v-col cols="3">
          <v-select
            dense
            v-model="form.dtmf"
            :error-messages="dtmfErrors"
            :items="dtmf"
            outlined
            label="DTMF"
            @input="$v.form.dtmf.$touch()"
            @blur="$v.form.dtmf.$touch()"
          />
        </v-col>
        <v-col cols="3">
          <v-select
            dense
            v-model="form.grupoCaptura"
            :items="grupoCapturaDisponiveis"
            label="Grupo de Captura"
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-select
            dense
            v-model="form.webrtc"
            :items="tipoRamal"
            label="Transporte"
            outlined
          />
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Codecs"
        :valoresDisponiveisComboBox="codecs.codecsDisponiveis"
        @dragUpdate="updateCodecs($event)"
        :opcoes-selecionadas="codecs.codecsSelecionadas"
        :canRender = "!form.webrtc"
      />
      <DraggAndDrop
        dragname="Rotas"
        :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
        @dragUpdate="updateRotasGeral($event)"
        :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
      />
      <DraggAndDrop
        dragname="Rotas de Transferência"
        :valoresDisponiveisComboBox="rotasTransferencias.rotasTransferenciasDisponiveis"
        @dragUpdate="updateRotasTransferencia($event)"
        :opcoesSelecionadas="rotasTransferencias.rotasTransferenciasSelecionadas"
      />

      <div v-for="n in 3" :key="`divider_${n}`">
        <v-divider vertical />
      </div>

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'

import DraggAndDrop from '../_components/DraggAndDrop'
import ramaisStore from '../_store'
import { validateData, validateComputed } from '../_validates/validatesPjsip'
import RamaisHttpService from '../_services/RamaisHttpService'

export default {
  name: 'AbaRamalPjsip',
  props: {
    edicao: String,
    _id: String,
  },
  components: { DraggAndDrop, Snackbar, FixedButtons },
  mixins: [validationMixin],

  data: () => ({
    form: {
      numero: '',
      usuario: '',
      senhaRamal: '',
      limiteLogin: 1,
      tipo: 'PJSIP',
      quantidadeChamadasParaOcupado: 1,
      dtmf: 'rfc4733',
      grupoCaptura: '',
      codecs: [],
      rotasTransferencias: [],
      rota: [],
      webrtc: false,
    },

    rotasTransferencias: {
      rotasTransferenciasDisponiveis: [],
      rotasTransferenciasSelecionadas: [],
    },
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    codecs: {
      codecsDisponiveis: ['alaw', 'ulaw', 'gsm', 'g729', 'h263', 'h264'],
      codecsSelecionadas: [],
    },
    dtmf: ['rfc4733', 'inband', 'info'],
    show: false,

    grupoCapturaDisponiveis: [''],
    item: -1,
    text: '',
    snackbar: false,
    desativado: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
    tipoRamal:[
      {
        text:"Padrão",
        value:false,
      },
      {
        text:"WEBRTC",
        value:true,
      }
    ],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('abaRamalPJSIPModulePABXStore', ['getRotasDisponiveis', 'getRamalSelecionado', 'getGrupos']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'abaRamalPJSIPModulePABXStore', ramaisStore)

    await Promise.all([this.listarRotas(), this.listarGrupo()])

    this.rotasTransferencias.rotasTransferenciasDisponiveis = [...this.getRotasDisponiveis]
    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    this.getGrupos.forEach(grupo => {
      if (grupo.tipo === 'GRUPOCAPTURA') {
        this.grupoCapturaDisponiveis.push({ text: grupo.description, value: grupo._id })
      }
      if (grupo.default) {
        this.form.grupoCaptura = grupo._id
      }
    })

    if (this.edicao === 'true') {
      this.desativado = true
      this.form = this.getRamalSelecionado

      const arrayrotasSelecionadas = Object.values(this.getRamalSelecionado.rota)
      const arrayrotasTransferenciaSelecionadas = Object.values(this.getRamalSelecionado.rotaTransferencia)

      arrayrotasSelecionadas.forEach(rotasSelecionadas => {
        const indexRotasGerais = this.rotasGerais.rotasGeralDisponiveis.findIndex(
          rotaDisponivel => rotaDisponivel._id === rotasSelecionadas
        )

        if (indexRotasGerais !== -1) {
          this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotasGerais])
        }
      })

      arrayrotasTransferenciaSelecionadas.forEach(rotasSelecionadas => {
        const indexRotaTransferencia = this.rotasTransferencias.rotasTransferenciasDisponiveis.findIndex(
          rotaTransferencia => rotaTransferencia._id === rotasSelecionadas
        )

        if (indexRotaTransferencia !== -1) {
          this.rotasTransferencias.rotasTransferenciasSelecionadas.push(
            this.rotasTransferencias.rotasTransferenciasDisponiveis[indexRotaTransferencia]
          )
        }
      })

      if (typeof this.form.codecs !== 'undefined') {
        this.codecs.codecsSelecionadas = [...this.form.codecs]
      }
    } else {
      this.codecs.codecsSelecionadas.push('alaw', 'ulaw', 'gsm')
      this.form.senhaRamal = this.keyGenerate()

      this.rotasTransferencias.rotasTransferenciasSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
      this.rotasGerais.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
    }

    ordenar(this.rotasTransferencias.rotasTransferenciasDisponiveis)
    ordenar(this.rotasGerais.rotasGeralDisponiveis)
    ordenar(this.codecs.codecsDisponiveis)

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('abaRamalPJSIPModulePABXStore', ['listarRotas', 'listarGrupo']),
    updateCodecs(event) {
      this.form.codecs = event
    },
    updateRotasGeral(event) {
      this.form.rota = formatarRota(event)
    },
    updateRotasTransferencia(event) {
      this.form.rotaTransferencia = formatarRota(event)
    },
    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.codecs.length) {
        this.text = 'Codec é obrigatório.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }
      if (!this.form.rota['1']) {
        this.text = 'Rota é obrigatória.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }
      if (!this.form.rotaTransferencia['1']) {
        this.text = 'Rota transferência é obrigatória.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') {
          delete this.form.numero
          await RamaisHttpService.putRamal(this.form)
        } else {
          await RamaisHttpService.postRamal(this.form)
        }
        this.$router.push({ name: 'Ramais' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Ramais' })
    },
    shuffle(string) {
      return string
        .split('')
        .sort(() => 0.5 - Math.random())
        .join('')
    },
    keyGenerate() {
      const upperLetter = `ABCDEFGHIJKLMNOPQRSTUVYXWZ`
      const lowerLetter = `abcdefghijklmnopqrstuvyxwz`
      const numbers = `0123456789`
      const specialCharacters = `!#$?%*`

      const shuffleUpperLetter = this.shuffle(upperLetter).substr(0, 2)
      const shuffleLowerLetter = this.shuffle(lowerLetter).substr(0, 2)
      const shuffleNumbers = this.shuffle(numbers).substr(0, 2)
      const shuffleSpecialCharacters = this.shuffle(specialCharacters).substr(0, 2)

      const keyUnique = `${shuffleUpperLetter}${shuffleLowerLetter}${shuffleNumbers}${shuffleSpecialCharacters}`

      return this.shuffle(keyUnique)
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
